var _style, _path, _path2, _path3, _defs, _g, _path4, _defs2, _g2, _path5, _polyline, _polyline2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#EC1966;}\n\t.st2{opacity:0.1;}\n\t.st3{clip-path:url(#SVGID_2_);}\n\t.st4{opacity:0.2;}\n\t.st5{clip-path:url(#SVGID_3_);}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:0.9;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -952.606,
    cy: -1388.4448,
    r: 11.0368,
    gradientTransform: "matrix(0 0.9583 -1.1749 0 -1619.2665 924.9141)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#00254F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9218,
    style: {
      stopColor: "#0F315E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C3B6A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.7,6.5V0.6c0-0.3,0.5-0.5,0.8-0.3l10.3,7.9c0.2,0.1,0.4,0.1,0.6,0l10.3-7.9c0.3-0.2,0.8-0.1,0.8,0.3v5.9 c0,0.1-0.1,0.2-0.1,0.3l-6.4,4.9c-0.2,0.1-0.2,0.4,0,0.5l6.4,4.9c0.1,0.1,0.1,0.2,0.1,0.3v5.9c0,0.3-0.5,0.5-0.8,0.3l-10.3-8 c-0.2-0.1-0.4-0.1-0.6,0l-10.3,8c-0.3,0.2-0.8,0.1-0.8-0.3v-5.9c0-0.1,0.1-0.2,0.1-0.3l6.4-4.9c0.2-0.1,0.2-0.4,0-0.5L0.8,6.8 C0.7,6.7,0.7,6.6,0.7,6.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,6.5L20.2,6.5c-0.1-0.1-0.1-0.1-0.1-0.1l-7.2-4.2c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.2-0.9-0.2-1.2,0L6.8,4.8 L3.9,6.4c0,0-0.1,0-0.1,0.1l0,0C3.4,6.8,3.1,7.2,3.1,7.6v8.6c0,0.6,0.3,1.1,0.8,1.3l7.4,4.3c0.4,0.2,0.9,0.2,1.3,0l7.6-4.4 c0.4-0.2,0.6-0.7,0.6-1.1V7.6C20.9,7.2,20.6,6.8,20.2,6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    d: "M3.1,7.8l0.1,8.4c0,0.6,0.3,1.1,0.8,1.4l7.2,4.2c0.3,0.1,0.6,0.1,0.7-0.2c0-0.1,0.1-0.2,0.1-0.3l-0.1-8.9 c0-0.2-0.1-0.4-0.3-0.5L3.9,7.4c-0.1,0-0.2-0.1-0.3-0.1C3.4,7.3,3.1,7.5,3.1,7.8C3.1,7.8,3.1,7.8,3.1,7.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M3.1,7.8l0.1,8.4c0,0.6,0.3,1.1,0.8,1.4l7.2,4.2c0.3,0.1,0.6,0.1,0.7-0.2c0-0.1,0.1-0.2,0.1-0.3l-0.1-8.9 c0-0.2-0.1-0.4-0.3-0.5L3.9,7.4c-0.1,0-0.2-0.1-0.3-0.1C3.4,7.3,3.1,7.5,3.1,7.8C3.1,7.8,3.1,7.8,3.1,7.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    transform: "matrix(0.8636 -0.5042 0.5042 0.8636 -6.3302 5.8153)",
    width: 15.1,
    height: 17.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    d: "M20.1,7.4l-7.9,4.5c-0.2,0.1-0.3,0.3-0.3,0.5l0.1,9c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.2,0,0.3-0.1l7.2-4.2 c0.5-0.3,0.8-0.8,0.8-1.4V7.8c0-0.3-0.2-0.5-0.5-0.5C20.3,7.3,20.2,7.3,20.1,7.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M20.1,7.4l-7.9,4.5c-0.2,0.1-0.3,0.3-0.3,0.5l0.1,9c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.2,0,0.3-0.1l7.2-4.2 c0.5-0.3,0.8-0.8,0.8-1.4V7.8c0-0.3-0.2-0.5-0.5-0.5C20.3,7.3,20.2,7.3,20.1,7.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 6.1,
    transform: "matrix(0.9297 -0.3683 0.3683 0.9297 -4.2247 7.0712)",
    width: 13.7,
    height: 16.9
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M11.3,5.2l2,1.2l0.1,0.1h0c0.2,0.1,0.4,0.4,0.4,0.7c0,0.5-0.6,0.9-1.4,0.9c-0.3,0-0.5,0-0.8-0.1l-0.3-0.2 L9.2,6.4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "15.8,16.9 15.8,13.3 17.9,15.7 17.9,12.3  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "6,16.8 6,12.2 9.2,14  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 6.1,
    y1: 14.7,
    x2: 8.6,
    y2: 16.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoX);
export default __webpack_public_path__ + "static/media/ico_x.82faf392c855ed14d5390c9feeb9fc01.svg";
export { ForwardRef as ReactComponent };